import React from 'react';
import MilestoneForm from '../../components/Milestones/MilestoneForm';

const MilestoneEdit = () => {
  return <MilestoneForm isEdit={true} />;
};

export default MilestoneEdit;


